import { Text, View } from '@react-pdf/renderer';
import { Tkv2PDFPage } from '../../components/Tkv2PDFPage.tsx';
import { CertificationStatementPageProps } from '../../types.ts';
import { certificationPageStyles as styles, fontStyles } from '../../styles.ts';
import { List } from '../../components/List.tsx';

export const CertificationStatementPage = ({
  subjectAddress,
}: CertificationStatementPageProps) => (
  <Tkv2PDFPage title="Certification" address={subjectAddress}>
    <View style={styles.certificationStatementPageContainer}>
      <View style={styles.certificationStatementTitleContainer}>
        <Text style={fontStyles.body}>
          I certify to the best of my knowledge and belief that:
        </Text>
      </View>
      <List
        type="bullet"
        items={[
          <Text style={fontStyles.body}>
            I have <Text style={fontStyles.bodyBold}>no present or prospective interest</Text> in the property that is the subject of this report, nor any relationship with the current or prospective owners, occupants, or parties involved.
          </Text>,
          <Text style={fontStyles.body}>
            I performed this assignment <Text style={fontStyles.bodyBold}>without bias</Text> with respect to the parties involved, the property, or the demographics of the area.
          </Text>,
          <Text style={fontStyles.body}>
            I have <Text style={fontStyles.bodyBold}>complied with all applicable laws and regulations</Text>, including federal and state <Text style={fontStyles.bodyBold}>antidiscrimination laws</Text>.
          </Text>,
          <Text style={fontStyles.body}>
            I did not base any part of my analysis or value conclusion on race, color, religion, sex (including sexual orientation or gender identity), age (except in legally age-restricted housing), marital status, disability, familial status, or national origin, or any other factor prohibited by the <Text style={fontStyles.bodyBold}>Fair Housing Act</Text> or <Text style={fontStyles.bodyBold}>Equal Credit Opportunity Act</Text>.
          </Text>,
          <Text style={fontStyles.body}>
            The analyses, opinions, and conclusions stated are my <Text style={fontStyles.bodyBold}>personal, unbiased, and professional</Text> work, subject only to the stated assumptions and limiting conditions.
          </Text>,
          <Text style={fontStyles.body}>
            I have, at minimum, developed and reported this appraisal in accordance with the scope of work described in this report.
          </Text>,
          <Text style={fontStyles.body}>
            I meet the <Text style={fontStyles.bodyBold}>credential and competency requirements</Text> for this assignment and have knowledge and experience in appraising this property type and market area.
          </Text>,
          <Text style={fontStyles.body}>
            I am aware of and have access to appropriate <Text style={fontStyles.bodyBold}>public and private data sources</Text> including MLS, tax records, and land records.
          </Text>,
          <Text style={fontStyles.body}>
            I obtained information from sources I believe to be reliable and true.
          </Text>,
          <Text style={fontStyles.body}>
            I performed this appraisal in accordance with <Text style={fontStyles.bodyBold}>USPAP</Text> as adopted by the <Text style={fontStyles.bodyBold}>Appraisal Standards Board</Text>.
          </Text>,
          <Text style={fontStyles.body}>
            Using information available in the normal course of business, I researched, verified, and analyzed any current or prior sale or listing of the subject property within <Text style={fontStyles.bodyBold}>three years</Text> prior to the effective date of this appraisal.
          </Text>,
          <Text style={fontStyles.body}>
            I researched, verified, and analyzed prior sales of comparable properties for at least <Text style={fontStyles.bodyBold}>one year</Text> prior to their sale dates.
          </Text>,
          <Text style={fontStyles.body}>
            I based my valuation on available properties most similar to the subject, identified material differences, and reflected market reactions to those differences.
          </Text>,
          <Text style={fontStyles.body}>
            I considered all factors affecting value and noted any adverse influences impacting marketability.
          </Text>,
          <Text style={fontStyles.body}>
            I have not knowingly withheld any significant information; all statements in this report are true and correct.
          </Text>,
          <Text style={fontStyles.body}>
            My <Text style={fontStyles.bodyBold}>employment and compensation</Text> were not contingent on any predetermined result, direction in value, or outcome favorable to any party.
          </Text>,
          <Text style={fontStyles.body}>
            I have not authorized any <Text style={fontStyles.bodyBold}>unauthorized changes</Text> to this report and take no responsibility for alterations made without my consent.
          </Text>,
          <Text style={fontStyles.body}>
            I identified the <Text style={fontStyles.bodyBold}>client/lender</Text> as the organization that ordered and will receive this appraisal report.
          </Text>,
          <Text style={fontStyles.body}>
            I am aware that disclosure or distribution of this report may be subject to law and to USPAP's confidentiality provisions.
          </Text>,
          <Text style={fontStyles.body}>
            The lender/client may disclose this report to the borrower, other lenders at the borrower's request, the mortgagee or its assigns, mortgage insurers, GSEs, secondary market participants, data services, regulators, and professional organizations without obtaining further consent.
          </Text>,
          <Text style={fontStyles.body}>
            Receipt of this report by any party does <Text style={fontStyles.bodyBold}>not</Text> make that party an intended user unless specifically identified as such.
          </Text>,
          <Text style={fontStyles.body}>
            If transmitted electronically, my <Text style={fontStyles.bodyBold}>digital signature</Text> has the same legal effect as my handwritten signature.
          </Text>,
          <Text style={fontStyles.body}>
            Any intentional or negligent misrepresentation in this report may result in civil or criminal liability under <Text style={fontStyles.bodyBold}>Title 18, United States Code, Section 1001</Text> or similar state laws.
          </Text>
        ]}
      />
    </View>
  </Tkv2PDFPage >
)
